import { Col, Row } from 'react-bootstrap'
import '../styles/Button.css'

const Button = ({ cancelBtn, submitBtn, loading, disabled, submitText = "Save", isShowCancel = true, type = "submit", buttonExtraCss = "", shouldRow = true, isShowSubmitBtn = true }) => {
  return (
    <>
      {
        shouldRow ?
          <Row>
            {
              isShowCancel &&
              <Col md={3}>
                <button className='cancel_btn' type='button' onClick={cancelBtn}>Cancel</button>
              </Col>
            }
            {
              isShowSubmitBtn &&
              <Col md={isShowCancel ? 9 : 12}>
                <button
                  type={type}
                  className={`save_btn ${buttonExtraCss}`}
                  onClick={submitBtn}
                  disabled={disabled || loading}
                >
                  {loading ? 'Loading......' : submitText}
                </button>
              </Col>
            }
          </Row> :
          <>
            <button className='cancel_btn' type='button' onClick={cancelBtn}>Cancel</button>
            {
              isShowSubmitBtn &&
              <button
                type={type}
                className={`save_btn ${buttonExtraCss}`}
                onClick={submitBtn}
                disabled={disabled || loading}
              >
                {loading ? 'Loading......' : submitText}
              </button>
            }
          </>
      }
    </>
  )
}

export default Button